import styles from '../../payment-form/payment-form.module.scss';
import Input from '../../input/input';

type Props = {
    onInput: (value: string) => void;
};

const ZelleForm = ({ onInput }: Props) => (
    <form className={styles.paymentForm}>
        <div className={styles.info}>
            <span>A nuestra cuenta Zelle:</span>
            <span className={styles.zelleEmail}>fin@panatech.io</span>
            <span className={styles.companyName}>
                PANA CORPORATE SERVICES, LLC.
            </span>
        </div>
        <Input placeholder={'Nombre del titular en Zelle'} onInput={onInput} />
    </form>
);

export { ZelleForm };
